export const RightArrowAltIcon = ({ color = '#6B7A86' }: { color?: string }): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 7.96631H16" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 3L16 7.96622L11 12.9324" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
